import React, { useEffect } from 'react';
import './InstaPost.css';
import { Fade } from "react-awesome-reveal";

function InstaPost() {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://www.instagram.com/embed.js');
    script.setAttribute('async', '');
    document.body.appendChild(script);
  }, []);

  const posts = [
    'https://www.instagram.com/reel/DMONqzTsmRo/?igsh=MTd6d3pwazk4dDVneQ==',
    'https://www.instagram.com/p/CyV6_1ov7Jo/?igsh=eW45NXVuNW5oZjUx',
    'https://www.instagram.com/p/Cz3fcGivDls/?igsh=MjM4N293ampyY25n',
    'https://www.instagram.com/reel/DH5q3QAym5E/?igsh=YmU3dW4zNm40NGVu'
  ];

  return (
    <div className="insta-wrapper">
      <Fade direction="down" triggerOnce={false}>
        <h2>Featured Instagram Posts</h2>
      </Fade>
      <div className="insta-row">
        {posts.map((url, index) => (
          <Fade
            key={index}
            direction="left"
            duration={800}
            delay={index * 300} // Delay each card slightly for staggered effect
            triggerOnce={false}
          >
            <blockquote
              className="instagram-media"
              data-instgrm-permalink={url}
              data-instgrm-version="14"
              style={{
                background: "#FFF",
                border: "none",
                margin: "0 1rem",
                maxWidth: "300px"
              }}
            ></blockquote>
          </Fade>
        ))}
      </div>

    </div>
  );
}

export default InstaPost;
